/**
 * Copyright 2019 Ginih (https://www.ginih.com)
 * Created By Marlon
 * Coded by Ginih Team
 **/

import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// react plugin for creating charts
// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Button from "@material-ui/core/Button";
// core components
import GridItem from "../../../components/Grid/GridItem.jsx";
import GridContainer from "../../../components/Grid/GridContainer.jsx";
import Card from "../../../components/Card/Card.jsx";
import CardBody from "../../../components/Card/CardBody.jsx";
import CardFooter from "../../../components/Card/CardFooter.jsx";
import CustomButton from "../../../components/CustomButtons/Button";
import dashboardStyle from "../../../assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import Muted from "../../../components/Typography/Muted";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { withRouter } from "react-router-dom";
import { getData, nullController } from "../../../utils/helpersFunctions";
import applicationDetails from "../../../models/ApplicationModel";
import { IMG_APP_CARD } from "../../../variables/resourcesConstants";
import AppRoleAssignmentForm from "./AppRoleAssignmentForm";
import RoleApplicationsDetails from "./RoleApplicationsDetails";
import { withTranslation } from "react-i18next";

class QuickActionsRole extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            role: getData("role"),
            openRole: false,
            openApp: false,
            isLoading: true,
            isQuickStartApp: true,
            isQuickStart: false,
        };
        this.closeForm = this.closeForm.bind(this);
        this.changeQuickStart = this.changeQuickStart.bind(this);
    }

    componentWillUnmount() {
        // removeData("role");
    }

    componentDidMount() {
        this._isMounted = false;
    }

    openAppForm = () => {
        applicationDetails.cleanApplicationDetails();
        this.setState({ openApp: true });
    };
    closeAppForm = () => {
        this.setState({ openApp: false });
    };
    closeForm(state, value, type) {
        this.setState({ [state]: value });
        if (type) this.setState({ isQuickStart: false });
    }
    changeQuickStart(state, value) {
        this.setState({ [state]: value });
        if (this.state.isQuickStartApp === true) {
            this.setState({
                isQuickStart: true,
                isLoading: false,
            });
        } else {
            this.setState({
                isQuickStart: false,
                isLoading: false,
            });
        }
    }

    goToRole = () => {
        this.props.history.push("members");
    };

    render() {
        const { classes, t, routeProps } = this.props;

        //Set page title
        document.title = document.title
            ? document.title.split("-")[0].trim() + " - " + t(routeProps.name)
            : t(routeProps.name);

        return (
            <div>
                <GridContainer>
                    <GridItem xs={6} sm={6} md={6}>
                        <div>
                            <h3 className={classes.headTitle}>
                                {nullController(this.state.role, "name")}
                            </h3>
                            <Muted>
                                {nullController(this.state.role, "uuid")}
                            </Muted>
                        </div>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6}>
                        <div className={classes.rightPaper}>
                            {/*<CustomButton*/}
                            {/*    variant="outlined"*/}
                            {/*    color="white"*/}
                            {/*    className={classes.cancelButton}*/}
                            {/*>*/}
                            {/*    {t('EDIT_TEXT')}*/}
                            {/*</CustomButton>*/}
                            <CustomButton
                                color="primary"
                                onClick={this.goToRole}
                            >
                                {t("GO_TO_ROLES_TEXT")}
                            </CustomButton>
                        </div>
                    </GridItem>
                    {this.state.isQuickStart ? (
                        <GridItem xs={12} sm={12} md={12}>
                            <div className={classes.typo}>
                                <h4> {t("QUICK_START")} </h4>
                            </div>
                        </GridItem>
                    ) : null}
                </GridContainer>
                {this.state.isQuickStart ? (
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={4}>
                            <Card chart>
                                <div className={classes.center}>
                                    <img
                                        src={IMG_APP_CARD}
                                        width={"175px"}
                                        height={"175px"}
                                        alt={"Application"}
                                    />
                                </div>
                                <CardBody>
                                    <h4 className={classes.cardTitle}>
                                        {t("APPLICATION_TEXT")}
                                    </h4>
                                    <p className={classes.cardCategory}>
                                        {t("FORM_APP_ROLE_CARD")}
                                    </p>
                                </CardBody>
                                <CardFooter chart>
                                    <Button
                                        onClick={this.openAppForm}
                                        size="small"
                                        color="primary"
                                    >
                                        {t("BTN_ASSIGN_APP")}
                                    </Button>
                                </CardFooter>
                            </Card>
                            <Dialog
                                maxWidth={"xs"}
                                fullWidth={true}
                                aria-labelledby="form-app-dialog-title"
                                open={this.state.openApp}
                                onClose={this.closeAppForm}
                            >
                                <DialogTitle id="form-app-dialog-title">
                                    {t("FORM_APP_TITLE")}
                                </DialogTitle>
                                <DialogContent>
                                    <AppRoleAssignmentForm
                                        closeForm={this.closeForm}
                                    />
                                </DialogContent>
                            </Dialog>
                        </GridItem>
                    </GridContainer>
                ) : (
                    <RoleApplicationsDetails
                        quickAction={this.changeQuickStart}
                    />
                )}
            </div>
        );
    }
}

QuickActionsRole.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRouter(
    withStyles(dashboardStyle)(withTranslation()(QuickActionsRole))
);
